
import { Product } from "@/models/base";
import { ProductAwsDocument } from "@/models/base/product-aws-document";
import Vue from "vue";
import AppAwsFilesInfo from "@/components/aws-files-modules/AwsFilesInfo.vue";


export default Vue.extend({
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	computed: {
		items():ProductAwsDocument[] {
			return this.product.AWSDocuments.filter(f=>f.File != null);
		},
	},
	components: {
		AppAwsFilesInfo
	}
});
